<div style="flex: 1; display: flex; flex-direction: column; width: 100%; height: 100%" data-cy="image-date-dialog-container">
  <div style="background-color: var(--tdo-primary); color: white; flex-basis: 30px;" data-cy="image-date-dialog-header">
    <span style="position: relative; left: 8px; top: 6px;" data-cy="image-date-dialog-message">{{message}}</span>
  </div>
  <div style="flex-basis: 200px; display: flex; flex-direction: column;" data-cy="image-date-dialog-content">
    <div style="flex: 1;" data-cy="image-date-dialog-form">
      <div style="flex: 1;" data-cy="image-date-dialog-title-container">
        <mat-card-subtitle style="color: black; margin-left: 20px;" data-cy="image-date-dialog-subtitle">Use this Image date</mat-card-subtitle>
      </div>
      <mat-card-content data-cy="image-date-dialog-date-container">
        <input type="date" [(ngModel)]="imageDate" style="margin-left: 20px;" data-cy="image-date-dialog-date-input"/>
      </mat-card-content>
    </div>
    <div style="display: flex; flex-basis: 44px; width: 100%; padding: 2px;" data-cy="image-date-dialog-actions">
      <button (click)="cancel()" class="tdo-button primary-accent" style="margin-left: 220px; margin-right: 6px;" data-cy="image-date-dialog-cancel-button">Cancel</button>
      <button (click)="confirm()" [disabled]="isConfirmDisabled" class="tdo-button primary-accent" data-cy="image-date-dialog-confirm-button">Confirm</button>
    </div>

  </div>

</div>
